import { usePostInstitutionMaterialApi, usePutInstitutionMaterialApi } from 'api/institution_material'
import { CheckboxField, SelectField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { InstitutionMaterial, InstitutionMaterialForm } from 'entities/institution_material'
import { MaterialVersion } from 'entities/material_version'
import { MemoFormView } from 'components/memo/memo_form'
import { ThemeContext } from 'contexts/theme_context'

type NewEditInstitutionMaterialFormProps = {
    institutionMaterial: InstitutionMaterial
    show: boolean
    onClose: () => void
    onComplete?: () => void
    materialVersions: MaterialVersion[]
}

export const NewEditInstitutionMaterialForm = (props: NewEditInstitutionMaterialFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const editApi = usePutInstitutionMaterialApi()
    const newApi = usePostInstitutionMaterialApi()
    const form = useForm<InstitutionMaterialForm>(props.institutionMaterial)
    const theme = useContext(ThemeContext)

    useEffectSkipFirst(() => {
        form.set(props.institutionMaterial)
    }, [props.institutionMaterial])

    const handleSubmit = () => {
        if (form.object.id) {
            editApi.execute(form)
        } else {
            newApi.execute(form)
        }
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(editApi.loading)
        if (editApi.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [editApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(newApi.loading)
        if (newApi.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [newApi.loading])

    return (
        <Modal show={props.show} onHide={props.onClose} size={'lg'}>
            <Modal.Header closeButton>
                <Modal.Title>資材バージョンの設定</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {form.object.institution?.name && <div>施設: {form.object.institution.name}</div>}
                {form.object.material?.name && <div>資材: {form.object.material.name}</div>}
                {props.institutionMaterial.id && (
                    <div style={{ backgroundColor: theme.primary + '22', padding: 10, marginTop: 10 }}>
                        <MemoFormView
                            memoSearchForm={{ objectId: props.institutionMaterial.id, modelName: 'institutionmaterial' }}
                            memoForm={{ objectId: props.institutionMaterial.id, modelName: 'institutionmaterial' }}
                        />
                    </div>
                )}
                <div style={{ marginTop: 10 }}>
                    <SelectField
                        disabled={form.object.notApplicable}
                        form={form}
                        attr={'materialVersionId'}
                        required
                        apiError={newApi.apiError || editApi.apiError}
                        label="送付したバージョン"
                        selectItems={props.materialVersions.map((v) => {
                            return { label: 'Ver.' + v.number, value: v.id! }
                        })}
                        includeBlank
                    />
                    <CheckboxField form={form} attr="notApplicable" checkboxLabel="資材管理対象外にする" apiError={newApi.apiError || editApi.apiError} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleSubmit}>
                    設定
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
